import { createContext, useState, useContext } from "react";
import { User } from "../models";
import { AccountInfo } from "@azure/msal-browser";

type UserContextType = {
	user?: User;
	setUser: (value?: User) => void;
	account?: AccountInfo;
	setAccount: (value?: AccountInfo) => void;
};

type UserContextProviderProps = {
	children: React.ReactNode;
};

const UserContext = createContext<UserContextType | undefined>(undefined);

export const UserProvider = ({ children }: UserContextProviderProps) => {
	const [user, setUser] = useState<User | undefined>(undefined);
	const [account, setAccount] = useState<AccountInfo | undefined>(undefined);

	return (
		<UserContext.Provider value={{ user, setUser, account, setAccount }}>
			{children}
		</UserContext.Provider>
	);
};

export const useUserContext = () => {
	const context = useContext(UserContext);
	if (context === undefined) {
		throw new Error("useUserContext must be used within a UserProvider");
	}
	return context;
};
